var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse2, _ellipse3, _ellipse4, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportGettingStartedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 84.394,
    viewBox: "0 0 126.076 84.394",
    width: 126.076,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_getting_started_icon_svg__a",
    gradientUnits: "objectBoundingBox",
    x1: -0.447,
    x2: 3.305,
    y1: 3.01
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m85.754 527.4h2.092l1-7.623h-3.092z",
    fill: "#ffb6b6",
    transform: "translate(-72.715 -445.132)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m270.705 723.788h6.435v-.077a2.438 2.438 0 0 0 -2.5-2.365l-1.175-.842-2.193.842h-.562z",
    fill: "#2f2e41",
    transform: "translate(-257.74 -639.46)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m107.98 472.847 1.647 1.219 5.761-5.421-2.431-1.8z",
    fill: "#ffb6b6",
    transform: "translate(-91.562 -399.804)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m284.179 664.334 5.066 3.748.05-.061a2.279 2.279 0 0 0 -.427-3.321l-.375-1.348-2.276-.614-.442-.327z",
    fill: "#2f2e41",
    transform: "translate(-269.165 -589.71)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m254.382 422.936s2.777 2.72 1.543 9.035l1.036 10.812.267.5a1.522 1.522 0 0 1 -.312 1.837l-.22.645-.206 1.263-7.663 10.881-2.927-2.909 4.732-10.2-1.286-2.623-2.983-9.132-2.063 16.704.411 14.378h-3.938l-2.44-16.029-2.572-22.538 1.338-2.623z",
    fill: "#2f2e41",
    transform: "translate(-228.112 -384.626)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m224.526 268.309-.028-.037c-1.5-1.982.755-6.744 1.1-7.434a1.733 1.733 0 0 1 -1.256-1.851l.147-1.177.153-1.154-1.094-1.034v-.026l-.63-5.2-.916-3.457a7.32 7.32 0 0 1 2.281-7.355l2.117-.317 2.572-2.341h4.148l1.422 1.284c2.655.44 3.111.3 5.392 2.881l-1.036 8.037-.259 1.106v1.5l.657.69a2.065 2.065 0 0 1 .539 1.857l-.086.408c.678.274 1.325 5.151 1.479 5.832l.231 1.017a9.376 9.376 0 0 1 1.5 2.337c0 .067-.053.133-.166.2-.888.568-4.431 4.6-6.6 3.777-2.315-.874-11.518.437-11.611.451z",
    fill: "#3f3d56",
    transform: "translate(-216.233 -225.325)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m212.529 343.746s1.065-5.686-.008-7.825l-4.258.287.648 8.112 3.722 9.007a1.59 1.59 0 0 0 1.07 1.8 1.745 1.745 0 0 0 2.062-.7 1.542 1.542 0 0 0 -.383-2.036z",
    fill: "#ffb6b6",
    transform: "translate(-204.793 -310.108)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m204.024 262.682.263-2.71a7.649 7.649 0 0 1 2.95-5.278 3.773 3.773 0 0 1 3.769-.47 3.325 3.325 0 0 1 1.856 4.289c-.984 2.437-.629 5.015-2.547 5.329l.208.937-1.887 5.815-5.373-.588z",
    fill: "#3f3d56",
    transform: "translate(-200.554 -239.884)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m347.585 336.3s-3.119-4.967-5.409-5.927l-3.029 2.84 6.092 5.751 9.041 4.536a1.744 1.744 0 0 0 2.057.708 1.591 1.591 0 0 0 1.082-1.8 1.675 1.675 0 0 0 -1.7-1.307z",
    fill: "#ffb6b6",
    transform: "translate(-315.775 -305.353)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m306.319 268.038-1.672-2.217a7.435 7.435 0 0 1 -1.407-5.821 3.477 3.477 0 0 1 2.533-2.678 3.644 3.644 0 0 1 4.368 2.109c.937 2.454 4.355 6.487 3.117 7.907l.8.582 1.216 3.272-4.48 2.864z",
    fill: "#3f3d56",
    transform: "translate(-285.227 -242.686)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.525,
    cy: 6.114,
    fill: "#ffb6b6",
    rx: 4.607,
    ry: 4.351
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m258.3 219.49c-.04-.033-.078-.069-.117-.1v.011z",
    fill: "#2f2e41",
    transform: "translate(-247.122 -210.309)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m253.123 157.692a2.553 2.553 0 0 0 -.923-.84 4.011 4.011 0 0 0 -.806-.27l-.729-.188a6.08 6.08 0 0 0 -1.147-.218 3 3 0 0 0 -2.7 1.382c-.22.369-.4.829-.822.964-.343.109-.717-.045-1.077-.015a1.293 1.293 0 0 0 -.985.685 2.515 2.515 0 0 0 -.258 1.169 6.383 6.383 0 0 0 2.208 4.89c.119-.3-.077-.616-.232-.9s-.253-.686.009-.892c.292-.23.76-.007 1.1-.157a.725.725 0 0 0 .386-.585c.033-.238 0-.48.014-.719a1.766 1.766 0 0 1 .648-1.244 1.979 1.979 0 0 1 1.391-.441c.786.053 1.549.56 2.3.352a7.082 7.082 0 0 1 1.025-.389 1.876 1.876 0 0 1 1.134.378 3.644 3.644 0 0 0 -.536-2.962z",
    fill: "#2f2e41",
    transform: "translate(-234.822 -156.173)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m378.756 707.444-1.172-1.779-.234 1.017c-.041.178-.082.359-.12.538-.333-.269-.687-.517-1.034-.755q-1.6-1.094-3.192-2.191l.333 1.824a12.376 12.376 0 0 0 .928 3.3c.056.116.117.231.182.343h4.953a1.44 1.44 0 0 0 .082-.322.106.106 0 0 0 0-.022 3.115 3.115 0 0 0 -.726-1.953z",
    fill: "#f0f0f0",
    transform: "translate(-344.483 -625.56)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m916.732 678.673-2.126-3.227-.425 1.844c-.074.323-.149.651-.218.977-.6-.487-1.247-.938-1.875-1.37q-2.9-1.985-5.789-3.975l.6 3.308a22.444 22.444 0 0 0 1.682 5.978c.1.211.212.419.331.623h8.975a2.6 2.6 0 0 0 .149-.583.186.186 0 0 0 0-.039 5.652 5.652 0 0 0 -1.304-3.536z",
    fill: "#f0f0f0",
    transform: "translate(-796.686 -598.711)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m311.334 741.492-125.714.044a.171.171 0 1 1 0-.342l125.714-.044a.171.171 0 1 1 0 .342z",
    fill: "#cacaca",
    transform: "translate(-185.439 -657.141)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m444.832 382.659v41.219a2.043 2.043 0 0 0 2.1 1.981h64.676a2.043 2.043 0 0 0 2.1-1.981v-41.22a2.045 2.045 0 0 0 -2.1-1.979h-64.678a2.045 2.045 0 0 0 -2.098 1.98z",
    fill: "#3f3d56",
    transform: "translate(-405.389 -348.439)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m454.81 391.7v40.2a1.093 1.093 0 0 0 1.121 1.059h63.6a1.093 1.093 0 0 0 1.121-1.059v-40.2a1.093 1.093 0 0 0 -1.121-1.061h-63.6a1.093 1.093 0 0 0 -1.121 1.061z",
    fill: "#fff",
    transform: "translate(-413.85 -356.971)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m434.339 697.026a1.287 1.287 0 0 0 .99.447h69.253a1.3 1.3 0 0 0 .988-.445 1.154 1.154 0 0 0 .258-1.005l-1.075-4.823a1.228 1.228 0 0 0 -.793-.874 1.3 1.3 0 0 0 -.452-.081h-67.108a1.3 1.3 0 0 0 -.452.081 1.228 1.228 0 0 0 -.793.874l-1.075 4.823a1.153 1.153 0 0 0 .259 1.003z",
    fill: "#2f2e41",
    transform: "translate(-396.249 -613.547)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f3d56"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 106.766 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 102.5 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 98.234 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 93.968 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 89.702 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 85.436 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 81.17 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 76.904 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 72.639 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 68.372 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 64.107 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 59.841 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 55.575 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 51.309 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 47.043 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 42.777 78.775)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 106.816 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 102.55 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 98.284 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 94.018 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 89.752 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 85.487 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 81.221 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 76.955 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 72.689 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 68.423 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 64.157 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 59.891 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 55.625 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 51.359 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 47.093 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 42.827 80.79)",
    width: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.209,
    rx: 0.488,
    transform: "matrix(-1 0 0 -1 81.626 83.207)",
    width: 17.064
  }), /*#__PURE__*/React.createElement("path", {
    d: "m606.073 478.977c-.015 7.033-5.708 12.894-13.127 13.512s-14.11-4.211-15.428-11.134 3.174-13.651 10.356-15.512 14.681 1.76 17.288 8.348c.031.08.062.16.092.24q.2.531.351 1.083a12.967 12.967 0 0 1 .468 3.463z",
    transform: "translate(-517.705 -420.955)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m657.745 519.887a.4.4 0 0 0 .044-.044z",
    fill: "#6c63ff",
    transform: "translate(-585.927 -467.616)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m697.716 596.566.013-.024z",
    fill: "#6c63ff",
    transform: "translate(-619.82 -533.302)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m629.141 492.622a5.117 5.117 0 0 0 -4.267-.165 2.228 2.228 0 0 0 -1.424 1.48c.805-.449 1.847.26 2.054 1.4l-.048.013a2.672 2.672 0 0 0 .608 2.134 1.5 1.5 0 0 1 .763-1.068 3 3 0 0 0 1-.743 4.568 4.568 0 0 0 .519-1.668c.121-.589.354-1.219.795-1.383z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-556.847 -443.832)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m588.542 497.382a4.988 4.988 0 0 1 -.788.762 1.687 1.687 0 0 0 -.573 1.012c-.034.275.019.555.011.833s-.105.591-.306.661c-.316.108-.558-.447-.883-.486-.258-.03-.491.353-.416.686s.427.48.629.263a.677.677 0 0 1 -.221.9c-.029.182-.058.364-.086.547a9.4 9.4 0 0 1 -1.985-1.6 4.709 4.709 0 0 1 -1.169-2.609 5.4 5.4 0 0 0 -.338-2.248 1.322 1.322 0 0 0 -1.279-.55c-.084.005-.17.014-.254.024a13.16 13.16 0 0 1 1.037-2.243 1.027 1.027 0 0 0 .26-.153c.431-.346.623-1.046.973-1.53q.034-.047.07-.091a3.338 3.338 0 0 1 1.3-.88 6.869 6.869 0 0 1 3.166-.882l-.308.028-1.08 2.855q-.082.219-.166.439a4.3 4.3 0 0 0 -.384 1.723 1.028 1.028 0 0 0 .4.865c.234.114.49-.026.716-.164l.287-.174a1.291 1.291 0 0 1 1.087-.284 1.2 1.2 0 0 1 .625 1.014 1.94 1.94 0 0 1 -.325 1.282z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-520.754 -441.889)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m623.518 577.152-3.011-1.751.017-.041c-.624.224-.883 1.272-.78 2.129s.453 1.623.63 2.458a6.18 6.18 0 0 1 -.26 3.423 28.153 28.153 0 0 0 3.487-4.538 2.363 2.363 0 0 0 .315-.66 1 1 0 0 0 -.074-.747.867.867 0 0 0 -.324-.273z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-553.686 -515.161)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m618.055 509.47a1 1 0 0 0 -.051.762.877.877 0 0 0 .5.437l.555.26a.751.751 0 0 0 .572.1.706.706 0 0 0 .343-.733 1.293 1.293 0 0 0 -.47-.754l-.86-.816-.162.187a2.047 2.047 0 0 0 -.427.557z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-552.185 -458.098)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m676.316 503.505.749.166a2.132 2.132 0 0 1 -1.021 1.8 1.941 1.941 0 0 0 -.687.36 1.917 1.917 0 0 0 -.345.762l-.427 1.469c-.153.528-.349 1.114-.747 1.3a.849.849 0 0 1 -.994-.372 4.355 4.355 0 0 1 -.578-1.225 1.238 1.238 0 0 1 -.56 1.115.75.75 0 0 1 -.966-.356c-.161-.267-.228-.619-.385-.889s-.489-.426-.661-.172a2.2 2.2 0 0 0 -.155.642.721.721 0 0 1 -.617.56 1.055 1.055 0 0 1 -.738-.319 3.1 3.1 0 0 1 -.917-1.746 1.971 1.971 0 0 1 .026-.955c.1-.3.338-.524.576-.467a.5.5 0 0 0 -.43-.689c-.279.036-.5.318-.725.535s-.547.374-.776.159a.288.288 0 0 1 -.087.224.324.324 0 0 1 -.233.092 1.165 1.165 0 0 1 -.416-.208 1.161 1.161 0 0 0 -1.566.481c.233-.938.575-2.014 1.293-2.235.293-.09.613-.016.889-.173a1.3 1.3 0 0 0 .166-1.758 1.6 1.6 0 0 1 -.185 1.166.392.392 0 0 1 -.679-.316.283.283 0 0 1 -.231.242.3.3 0 0 1 -.315-.132.946.946 0 0 1 -.031-.839 1.98 1.98 0 0 1 .469-.629 5.661 5.661 0 0 1 1.213-1.022 1.444 1.444 0 0 1 1.4-.084c.234.128.44.341.679.453a.529.529 0 0 0 .388.057.5.5 0 0 0 .313-.223c.178-.295.094-.733.16-1.1.118-.651.808-.956 1.19-.526-.286-.069-.581.25-.617.637a.9.9 0 0 0 .448.895c.465.195.921-.295 1.273-.748q.55-.712 1.1-1.422a1.743 1.743 0 0 1 .2-.227.662.662 0 0 1 .867-.017c.372.287.547.874.852 1.279a2.536 2.536 0 0 0 1.722.845l1.38.255a13.142 13.142 0 0 1 .8 1.67 4.777 4.777 0 0 0 -2.064 1.685z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-590.922 -448.585)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m760.678 529.636a2.6 2.6 0 0 0 -.153.814 1.949 1.949 0 0 1 -.2-1.9q.201.535.353 1.086z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-672.779 -475.076)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m738.291 597.7a13.5 13.5 0 0 1 -1.2 1.9c-.29-.117-.6.092-.873.288s-.624.405-.914.218a1.157 1.157 0 0 1 -.3-1.152 3 3 0 0 1 .557-1.082 2.183 2.183 0 0 1 .835-.826.654.654 0 0 1 .867.506l.238-.008a.434.434 0 0 1 .116-.6c.207-.074.386.195.509.432.057.111.113.219.165.324z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-651.411 -533.638)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m663.1 557.832c-.512.03-.918-.565-1.187-1.151a3.6 3.6 0 0 0 -.978-1.554 2.972 2.972 0 0 0 -.851-.276 1.037 1.037 0 0 1 -.723-.6l-.325-.124a4.883 4.883 0 0 0 -1.233.831 2.541 2.541 0 0 0 -.735 1.517 1.61 1.61 0 0 0 .6 1.53c.338.182.732.067 1.075.234a1.889 1.889 0 0 1 .779 1.412c.1.6.072 1.219.141 1.824a2.335 2.335 0 0 0 .651 1.544.944.944 0 0 0 1.433-.64c.108-.346.1-.737.185-1.1a5.678 5.678 0 0 1 .832-1.622 2.336 2.336 0 0 0 .336-1.825z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-585.344 -496.976)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m663.085 530.344a1.325 1.325 0 0 1 .133.134.419.419 0 0 1 -.008.454.456.456 0 0 0 .32-.154 1.948 1.948 0 0 0 .245-.326.341.341 0 0 0 .072-.285c-.024-.065-.081-.093-.122-.142a.93.93 0 0 1 -.112-.308.57.57 0 0 0 -.426-.424h.026a.225.225 0 0 0 -.114.245c.016.095.08.174.074.27-.009.139-.156.2-.166.344a.258.258 0 0 0 .078.192z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-590.39 -475.709)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m654.245 520.773a.408.408 0 0 0 .139-.418.27.27 0 0 0 -.29-.235.307.307 0 0 1 -.275.076c-.075-.018-.158-.065-.223-.012a.313.313 0 0 0 -.076.14l-.072.21a.126.126 0 0 0 -.009.08.071.071 0 0 0 .055.041l.434.121a.394.394 0 0 0 .317-.003z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-582.275 -467.85)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m726.1 583.452-.2-.31a1.05 1.05 0 0 0 -.264-.313.243.243 0 0 0 -.174-.05.238.238 0 0 0 -.16.082l.008.059a1.309 1.309 0 0 1 .352.649c.015.106.01.215.023.321a.365.365 0 0 0 .124.262c.105.066.229-.031.3-.151a.5.5 0 0 0 .085-.331.564.564 0 0 0 -.094-.218z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-643.215 -521.513)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m734.413 581.327a.678.678 0 0 0 -.025-.289.608.608 0 0 1 .1-.359 1.138 1.138 0 0 0 .159-.329.261.261 0 0 0 -.008-.161c-.022-.047-.076-.068-.106-.031l.066.04a.635.635 0 0 0 -.267.012.319.319 0 0 0 -.2.215 1.264 1.264 0 0 1 -.053.224c-.039.076-.115.1-.163.168a.383.383 0 0 0 .007.383.469.469 0 0 0 .267.2c.081.025.187.026.223-.073z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-650.476 -519.253)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m746.135 588.472a.854.854 0 0 0 .116.2c.089.085.211.033.319.012a.568.568 0 0 1 .525.2 1.28 1.28 0 0 0 -.769-.906 2.378 2.378 0 0 0 -.791-.117l-.046.011c.117.321.485.314.646.6z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-660.33 -525.866)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m694.275 597.229a2.326 2.326 0 0 0 -.159.33 2.735 2.735 0 0 0 -.115.564c-.014.109-.019.248.053.3a.107.107 0 0 0 .134-.017.5.5 0 0 0 .1-.136 3.046 3.046 0 0 0 .328-.734 1.211 1.211 0 0 0 -.054-.823z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-616.664 -533.447)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m677.009 497.646a.336.336 0 0 0 .348.064 1.157 1.157 0 0 0 .327-.2.746.746 0 0 0 .2-.2.394.394 0 0 0 .041-.316.337.337 0 0 0 -.259-.193l-.482-.135.116-.1c-.119-.061-.252.052-.326.191a.993.993 0 0 0 -.1.288.707.707 0 0 0 .135.601z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-602.13 -447.662)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m695.919 494.195a.276.276 0 0 0 .361.028.377.377 0 0 0 .16-.272c.011-.119-.051-.252-.14-.262l.021-.112c-.172-.029-.383-.035-.475.162a.442.442 0 0 0 .074.456z",
    fill: "url(#support_getting_started_icon_svg__a)",
    transform: "translate(-618.207 -445.109)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m535.677 439.577h-58.9a.146.146 0 1 1 0-.292h58.9a.146.146 0 1 1 0 .292z",
    fill: "#cacaca",
    transform: "translate(-432.35 -398.627)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.831,
    cy: 37.304,
    fill: "#3f3d56",
    rx: 1.661,
    ry: 1.604
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.57,
    cy: 37.304,
    fill: "#3f3d56",
    rx: 1.661,
    ry: 1.604
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.309,
    cy: 37.304,
    fill: "#3f3d56",
    rx: 1.661,
    ry: 1.604
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m817.894 407.532h-4.077a.292.292 0 1 0 0 .583h4.077a.292.292 0 1 0 0-.583z",
    fill: "#3f3d56",
    transform: "translate(-718.006 -371.434)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m817.894 415.152h-4.077a.292.292 0 1 0 0 .583h4.077a.292.292 0 1 0 0-.583z",
    fill: "#3f3d56",
    transform: "translate(-718.006 -377.96)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m817.894 422.762h-4.077a.292.292 0 1 0 0 .583h4.077a.292.292 0 1 0 0-.583z",
    fill: "#3f3d56",
    transform: "translate(-718.006 -384.477)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m534.908 541.438c.948-.39-.974-.618-3.156-.692s-4.82-.071-6.213-.283c-1.348-.206-1.249-.571-1.362-.9s-.632-.671-2.735-.744c-2.621-.092-6.944.261-8.922.049-1.846-.2-.749-.818-3.441-.842-1.537-.014-3.518.191-5.229.24a20.168 20.168 0 0 1 -3.628-.179c-.834-.129-1.415-.293-2.353-.407a67.67 67.67 0 0 0 -11.587.185 57.269 57.269 0 0 0 -10.07 1.634c-2.08.622-2.655 1.235-2.17 1.755.309.332 1.1.642 3.021.776 3.592.249 9.987-.18 13.7.047 2.069.126 2.986.44 4.8.612 1.95.184 4.8.194 7.609.19 5.84-.009 11.829-.066 17.936-.17 2.551-.043 5.223-.1 7.938-.307s5.483-.606 6.055-.98",
    fill: "#fff",
    opacity: 0.35,
    transform: "translate(-430.02 -482.741)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportGettingStartedIcon);
export default __webpack_public_path__ + "static/media/support_getting_started_icon.8f6d6e020fda4fcfef1d56a9166aa906.svg";
export { ForwardRef as ReactComponent };